import {Routes} from '@angular/router';
import {MainViewComponent} from "src/app/presentation/main-view/main-view.component";
import {LoginPage} from 'src/app/presentation/login/login-page.component';
import {
  InformationCenterComponent
} from 'src/app/presentation/main-view/information-center/information-center.component';
import {
  GrazingPatternsComponent
} from 'src/app/presentation/main-view/information-center/animals/grazing-patterns/grazing-patterns.component';
import {SettingsComponent} from 'src/app/presentation/main-view/settings/settings.component';
import {
  AnimalEditFormComponent
} from 'src/app/presentation/main-view/information-center/animals/animal-edit-form/animal-edit-form.component';
import {
  DeleteAnimalsFormComponent
} from 'src/app/presentation/main-view/information-center/animals/delete-animals-form/delete-animals-form.component';
import {
  DeveloperConsoleComponent
} from 'src/app/presentation/main-view/settings/developer-console/developer-console.component';
import {
  AddAnimalComponent
} from 'src/app/presentation/main-view/information-center/animals/add-animal/add-animal.component';
import {NotificationsComponent} from 'src/app/presentation/main-view/notifications/notifications.component';
import {FarmsComponent} from 'src/app/presentation/main-view/information-center/farms/farms.component';
import {AnimalsComponent} from 'src/app/presentation/main-view/information-center/animals/animals.component';
import {
  PrecipitationPointsComponent
} from 'src/app/presentation/main-view/information-center/precipitation-sample-points/precipitation-points.component';
import {
  WaterPointsComponent
} from 'src/app/presentation/main-view/information-center/water-points/water-points.component';
import {
  ProximitySamplePointsComponent
} from 'src/app/presentation/main-view/information-center/proximity-sample-points/proximity-sample-points.component';
import {GatewaysComponent} from 'src/app/presentation/main-view/information-center/gateways/gateways.component';
import {
  AnimalDetailsComponent
} from 'src/app/presentation/main-view/information-center/animals/animal-details/animal-details.component';
import {
  WaterPointDetailsComponent
} from 'src/app/presentation/main-view/information-center/water-points/water-point-details/water-point-details.component';
import {
  CustomizeWaterSamplePointComponent
} from 'src/app/presentation/main-view/information-center/water-points/water-point-details/customize-asset/customize-water-sample-point.component';
import {
  GatewayDetailsComponent
} from 'src/app/presentation/main-view/information-center/gateways/gateway-details/gateway-details.component';
import {
  CustomizeGatewayComponent
} from 'src/app/presentation/main-view/information-center/gateways/gateway-details/customize-asset/customize-gateway.component';
import {
  ProximitySamplePointDetailsComponent
} from 'src/app/presentation/main-view/information-center/proximity-sample-points/proximity-sample-point-details/proximity-sample-point-details.component';
import {
  CustomizeProximitySamplePointComponent
} from 'src/app/presentation/main-view/information-center/proximity-sample-points/proximity-sample-point-details/customize-proximity-sample-point/customize-proximity-sample-point.component';
import {
  PrecipitationPointDetailsComponent
} from 'src/app/presentation/main-view/information-center/precipitation-sample-points/precipitation-sample-point-details/precipitation-sample-point-details.component';
import {
  CustomizePrecipitationSamplePointComponent
} from 'src/app/presentation/main-view/information-center/precipitation-sample-points/precipitation-sample-point-details/customize-precipitation-sample-point/customize-precipitation-sample-point.component';
import {AddDeviceComponent} from 'src/app/presentation/main-view/add-device/add-device.component';
import {
  AddProximitySamplePointComponent
} from 'src/app/presentation/main-view/add-device/add-proximity-sample-point/add-proximity-sample-point.component';
import {NearbyBleTagsComponent} from 'src/app/presentation/main-view/nearby-ble-tags/nearby-ble-tags.component';
import {
  UnassignedTagsComponent
} from 'src/app/presentation/main-view/information-center/unassigned-tags/unassigned-tags.component';
import {
  SetAnimalProfilePictureComponent
} from 'src/app/presentation/main-view/information-center/animals/animal-details/set-animal-profile-picture/set-animal-profile-picture.component';
import {AddGatewayComponent} from 'src/app/presentation/main-view/add-device/add-gateway/add-gateway.component';
import {
  SignalStrengthAnalysisComponent
} from 'src/app/presentation/main-view/signal-strength-analysis/signal-strength-analysis.component';
import {PaddocksComponent} from 'src/app/presentation/main-view/information-center/animals/paddocks/paddocks.component';
import {
  AddPaddocksComponent
} from 'src/app/presentation/main-view/information-center/animals/paddocks/add-paddocks/add-paddocks.component';
import {
  CustomizePaddockComponent
} from 'src/app/presentation/main-view/information-center/animals/paddocks/customize-paddock/customize-paddock.component';
import {
  HistoricalAnimalLocationsComponent
} from 'src/app/presentation/main-view/information-center/animals/animal-details/historical-animal-locations/historical-animal-locations.component';
import {
  CustomizeBluetoothProximitySensorComponent
} from 'src/app/presentation/main-view/information-center/proximity-sample-points/proximity-sample-point-details/customize-bluetooth-proximity-sensor/customize-bluetooth-proximity-sensor.component';
import {
  AnimalPingScheduleComponent
} from 'src/app/presentation/main-view/information-center/animals/animal-ping-schedule/animal-ping-schedule.component';
import {
  AddWaterPointComponent
} from 'src/app/presentation/main-view/add-device/add-water-point/add-water-point.component';
import {ReadNfcTagComponent} from 'src/app/presentation/main-view/read-nfc-tag/read-nfc-tag.component';
import {
  AnimalRelationships
} from "src/app/presentation/main-view/information-center/animals/animal-relationships/animal-relationships";

export const routes: Routes = [
  {
    path: 'login',
    component: LoginPage
  },
  {
    path: 'main',
    component: MainViewComponent,
    children: [
      {
        path: 'nearby-ble-tags',
        component: NearbyBleTagsComponent
      },
      {
        path: 'read-nfc-tag',
        component: ReadNfcTagComponent
      },
      {
        path: 'information-center',
        component: InformationCenterComponent
      },
      {
        path: 'grazing-patterns',
        component: GrazingPatternsComponent
      },
      {
        path: 'signal-strength-analysis',
        component: SignalStrengthAnalysisComponent
      },
      {
        path: 'edit-animal',
        component: AnimalEditFormComponent
      },
      {
        path: 'delete-animals',
        component: DeleteAnimalsFormComponent
      },
      {
        path: 'animal-relationships/:id',
        component: AnimalRelationships
      },
      {
        path: 'settings',
        component: SettingsComponent
      },
      {
        path: 'developer-console',
        component: DeveloperConsoleComponent
      },
      {
        path: 'add-animal',
        component: AddAnimalComponent
      },
      {
        path: 'add-device',
        component: AddDeviceComponent
      },
      {
        path: 'add-paddocks',
        component: AddPaddocksComponent
      },
      {
        path: 'add-proximity-sample-point',
        component: AddProximitySamplePointComponent
      },
      {
        path: 'add-gateway',
        component: AddGatewayComponent
      },
      {
        path: 'add-water-point',
        component: AddWaterPointComponent
      },
      {
        path: 'notifications',
        component: NotificationsComponent
      },
      {
        path: 'farms',
        component: FarmsComponent
      },
      {
        path: 'animals',
        component: AnimalsComponent
      },
      {
        path: 'paddocks',
        component: PaddocksComponent
      },
      {
        path: 'precipitation-sample-points',
        component: PrecipitationPointsComponent
      },
      {
        path: 'water-points',
        component: WaterPointsComponent
      },
      {
        path: 'proximity-sample-points',
        component: ProximitySamplePointsComponent
      },
      {
        path: 'gateways',
        component: GatewaysComponent
      },
      {
        path: 'animal-ping-schedule',
        component: AnimalPingScheduleComponent
      },
      {
        path: 'animal-details/:id',
        component: AnimalDetailsComponent
      },
      {
        path: 'animal-details/:id/historical-locations',
        component: HistoricalAnimalLocationsComponent
      },
      {
        path: 'animal-details/:id/set-profile-picture',
        component: SetAnimalProfilePictureComponent
      },
      {
        path: 'water-point-details/:id',
        component: WaterPointDetailsComponent
      },
      {
        path: 'customize-water-point/:id',
        component: CustomizeWaterSamplePointComponent
      },
      {
        path: 'gateway-details/:id',
        component: GatewayDetailsComponent
      },
      {
        path: 'customize-gateway/:id',
        component: CustomizeGatewayComponent
      },
      {
        path: 'proximity-sample-point-details/:id',
        component: ProximitySamplePointDetailsComponent
      },
      {
        path: 'customize-proximity-sample-point/:id',
        component: CustomizeProximitySamplePointComponent
      },
      {
        path: 'customize-bluetooth-proximity-sensor/:id',
        component: CustomizeBluetoothProximitySensorComponent
      },
      {
        path: 'precipitation-sample-point-details/:id',
        component: PrecipitationPointDetailsComponent
      },
      {
        path: 'customize-precipitation-sample-point/:id',
        component: CustomizePrecipitationSamplePointComponent
      },
      {
        path: 'unassigned-tags',
        component: UnassignedTagsComponent
      },
      {
        path: 'customize-paddock/:id',
        component: CustomizePaddockComponent
      },
    ]
  },
  {
    path: '**',
    redirectTo: '/main/information-center'
  },
];
